import * as dagre from "dagre";
import * as _ from "lodash";
import styles from '../../../../../assets/scss/globals/_variable.scss';
const size = {
    width: parseInt(styles.nodeWidth, 10),
    height: parseInt(styles.nodeHeight, 10)
};

export function distributeElements(model) {
    let clonedModel = _.cloneDeep(model);
    let nodes = distributeGraph(clonedModel);
    const clonedNodes = clonedModel.layers.filter(layer => layer.type === 'diagram-nodes')[0].models;
    nodes.forEach(node => {
        let modelNode = Object.values(clonedNodes).find(item => item.id === node.id);
        modelNode.x = node.x - node.width / 2;
        modelNode.y = node.y - node.height / 2;
    });
    return clonedModel;
}

function distributeGraph(model) {
    let nodes = mapElements(model);
    let graph = new dagre.graphlib.Graph();
    graph.setGraph({});
    graph.setDefaultEdgeLabel(() => ({}));
    graph.graph().rankDir = 'LR';
    graph.graph().nodesep = '50';
    graph.graph().ranksep = '100';
    nodes.forEach(node => {
        graph.setNode(node.id, node.metadata);
    });
    const links = model.layers.filter(layer => layer.type === 'diagram-links')[0].models;
    Object.values(links).forEach(edge => {
        if (edge.source && edge.target) {
            graph.setEdge(edge.source, edge.target);
        }
    });
    dagre.layout(graph);
    return graph.nodes().map(node => graph.node(node));
}

function mapElements(model) {
    let mappedElements = [];
    const nodes = model.layers.filter(layer => layer.type === 'diagram-nodes')[0].models;
    Object.values(nodes).forEach((node, index) => {
        mappedElements.push({ id: node.id, metadata: node });
        mappedElements[index].metadata.width = size.width;
        mappedElements[index].metadata.height = size.height;
    });
    return mappedElements;
}
